// src/interactiveUGC/pages/ChapterEditorInteractive.jsx
import * as React from 'react';
import Box from '@mui/material/Box';
import { ReactFlowProvider } from '@xyflow/react';
import InteractiveEditor from '../components/InteractiveEditor';
import { getInteractiveStoryDetails } from '../../utils/apis/interactiveStoriesAPI';

export default function ChapterEditorInteractive({ storyID, chapterIndex, isNew }) {
  const [chapterID, setChapterID] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        // CF returns { success, story } — but your client may already unwrap it.
        const res = await getInteractiveStoryDetails(storyID);
        const story = res?.story ?? res; // handle both shapes
        const chapters = Array.isArray(story?.chapters) ? story.chapters : [];

        // (optional) debug to confirm actual shape
        // console.debug('Interactive details:', { keys: Object.keys(story || {}), chaptersLen: chapters.length, story });

        const found = chapters.find(c => Number(c.index) === Number(chapterIndex));

        if (!cancelled) {
          if (!found?.id) {
            console.warn('No chapter id for index:', {
              storyID,
              chapterIndex,
              chaptersLen: chapters.length
            });
            setChapterID(null);
          } else {
            setChapterID(found.id);
          }
        }

      } catch (e) {
        if (!cancelled) {
          console.error('Failed to resolve chapterID from index:', e);
          setChapterID(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [storyID, chapterIndex, isNew]);

  if (loading) {
    return <Box sx={{ p: 2, height: '100dvh', boxSizing: 'border-box' }} />;
  }

  return (
    <Box sx={{ p: 2, height: '100dvh', boxSizing: 'border-box' }}>
      <ReactFlowProvider>
        <InteractiveEditor storyID={storyID} chapterID={chapterID} />
      </ReactFlowProvider>
    </Box>
  );
}
